<app-navbar />

<main id="main-content">
  <section class="page-hero">
    <div class="container">
      <app-breadcrumb [trail]="[{ label: 'Resources' }]" />
      <span class="eyebrow">Resource library</span>
      <h1>How fraud teams actually stop deceased identity abuse</h1>
      <p>
        Long form guides written for the people who own this problem. No gated forms, no lead
        capture, no fluff. Read them, forward them, use them in your own business case.
      </p>
    </div>
  </section>

  <section class="section">
    <div class="container">
      <a class="lead-article" [routerLink]="[routes.resources.url, featured.slug]">
        <div class="lead-article-body">
          <div class="lead-article-meta">
            <span class="tag">{{ featured.category }}</span>
            <span class="lead-article-flag">Start here</span>
          </div>
          <h2>{{ featured.title }}</h2>
          <p>{{ featured.excerpt }}</p>
          <div class="article-foot">
            <span>{{ featured.audience }}</span>
            <span class="article-dot" aria-hidden="true"></span>
            <span>{{ featured.readMinutes }} min read</span>
            <span class="article-dot" aria-hidden="true"></span>
            <span>Updated {{ formatDate(featured.updated) }}</span>
          </div>
          <span class="lead-article-link">Read the guide</span>
        </div>
        <div class="lead-article-aside">
          <span class="lead-article-icon" aria-hidden="true" [innerHTML]="iconFor(featured.icon)"></span>
          <span class="lead-article-aside-title">What you will get</span>
          <ul>
            @for (point of featured.keyTakeaways; track point) {
              <li>{{ point }}</li>
            }
          </ul>
        </div>
      </a>
    </div>
  </section>

  <section class="section section-alt">
    <div class="container">
      <div class="section-head">
        <span class="eyebrow">Everything else</span>
        <h2 class="section-title">Guides by the problem you are solving</h2>
        <p class="section-lead">
          Each one is built around a decision a real team had to make, from choosing a death data
          source to standing up a suppression process that survives an audit.
        </p>
      </div>

      <div class="category-filter" role="group" aria-label="Filter resources by category">
        @for (category of categories; track category) {
          <button
            type="button"
            class="category-chip"
            [class.active]="activeCategory() === category"
            [attr.aria-pressed]="activeCategory() === category"
            (click)="setCategory(category)">
            {{ category }}
          </button>
        }
      </div>

      <div class="article-grid">
        @for (article of visibleArticles(); track article.slug) {
          <a class="article-card" [routerLink]="[routes.resources.url, article.slug]">
            <span class="icon-badge" aria-hidden="true" [innerHTML]="iconFor(article.icon)"></span>
            <span class="tag">{{ article.category }}</span>
            <h3>{{ article.title }}</h3>
            <p>{{ article.excerpt }}</p>
            <div class="article-foot">
              <span>{{ article.audience }}</span>
              <span class="article-dot" aria-hidden="true"></span>
              <span>{{ article.readMinutes }} min read</span>
            </div>
          </a>
        }
      </div>

      @if (!visibleArticles().length) {
        <p class="text-center muted">Nothing in this category yet. More is on the way.</p>
      }
    </div>
  </section>

  <section class="section">
    <div class="container">
      <div class="cta-band">
        <h2>Want this applied to your own book?</h2>
        <p>
          Run a sample against fresh nationwide death data and see what is sitting in your portfolio
          right now. You only pay for confirmed matches.
        </p>
        <div class="actions-row center">
          <a class="btn btn-primary btn-lg" [routerLink]="[routes.accountRegister.url]">Start free</a>
          <a class="btn btn-outline btn-lg" [routerLink]="[routes.bookACall.url]">Book a call</a>
        </div>
      </div>
    </div>
  </section>
</main>

<app-footer />
